import { Checkbox, DataSource, Image, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEquipmentAssignments extends Layout {
    checkboxUnassignAll: Checkbox;
    imageInstructionalIcon: Image;
    imageInstructionalZmit: Image;
    labelInstrucitonalSendLoad: Label;
    labelInstructionManageP1: Label;
    labelInstructionManageP2: Label;
    labelUnassignPrompt: Label;
    panelActions: Panel;
    sourcePreassignments: DataSource;
    tableEquipmentAssignments: Table;
    textboxEquipment: Textbox;
}
